export enum JobType {
  items,
  search,
  map,
  cluster,
}

export type ProfessionQuery = {
  description: string
  id: string
  name: string
}
